module.exports = __webpack_public_path__ + "img/KH.251b1357.png";